import React from 'react';
import leftArrowSrc from '../svg/arrow-left.svg';

const LeftArrow = (props) => <img src={leftArrowSrc} alt="" {...props} />;

export default LeftArrow;
